var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 80.5C69.8 80.5 68 78.7 68 76.5V68.5C68 61.9 62.6 56.5 56 56.5H24C17.4 56.5 12 61.9 12 68.5V76.5C12 78.7 10.2 80.5 8 80.5C5.8 80.5 4 78.7 4 76.5V68.5C4 57.46 12.96 48.5 24 48.5H56C67.04 48.5 76 57.46 76 68.5V76.5C76 78.7 74.2 80.5 72 80.5Z",
    fill: "#20262D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40.5C28.96 40.5 20 31.54 20 20.5C20 9.46 28.96 0.5 40 0.5C51.04 0.5 60 9.46 60 20.5C60 31.54 51.04 40.5 40 40.5ZM40 8.5C33.4 8.5 28 13.9 28 20.5C28 27.1 33.4 32.5 40 32.5C46.6 32.5 52 27.1 52 20.5C52 13.9 46.6 8.5 40 8.5Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4f3ebb642c8e7b91199efc098eed9d4e.svg";
export { ForwardRef as ReactComponent };